import styled from 'styled-components';

import { BREAKPOINTS } from './spacing';

export const OnboardingBackground = styled.div<{ background?: string }>`
  background: ${({ theme, background }) =>
    background ? `url(${background})` : theme.COLORS.BACKGROUND_PRIMARY};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  overflow: hidden;
  transition: background-image 0.3s ease;

  video,
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const OnboardingContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.5rem;
  flex-direction: column;

  @media (min-width: ${BREAKPOINTS.WIDTH.MD}) {
    flex-direction: row;
  }

  @media (max-width: ${BREAKPOINTS.WIDTH.SM}) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0;
    margin: 0;
  }
`;

export const OnboardingContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  gap: 1rem;

  @media (max-width: ${BREAKPOINTS.WIDTH.SM}) {
    display: flex;
    width: 100%;
    height: 100vh;
    padding: 0;
    gap: 0;
    margin: 0;
  }

  @media (min-width: ${BREAKPOINTS.WIDTH.MD}) and (max-width: ${BREAKPOINTS.WIDTH.LG}) {
    flex-direction: column;
    max-width: 900px;
    justify-content: center;
  }

  @media (min-width: ${BREAKPOINTS.WIDTH.LG}) {
    flex-direction: row;
    justify-content: center;
    gap: 2rem;
  }
`;

export const OnboardingCard = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  //height: 32rem;
  max-width: 450px;
  margin-bottom: 1rem;
  position: relative;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media (max-width: ${BREAKPOINTS.WIDTH.MD}) {
    margin-bottom: 1rem;
  }

  @media (max-width: ${BREAKPOINTS.WIDTH.SM}) {
    height: 25vh;
    margin-bottom: 0;

    &::before {
      content: '';
      background: ${({ theme }) => theme.COLORS.BACKGROUND_PRIMARY};
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      transform: scale(1.5);
      z-index: -1;
    }
  }

  @media (min-width: ${BREAKPOINTS.WIDTH.MD}) and (max-width: ${BREAKPOINTS.WIDTH.LG}) {
    width: 100%;
    max-width: 350px;
  }

  @media (min-width: ${BREAKPOINTS.WIDTH.LG}) {
    max-width: 450px;
  }
`;

export const OnboardingImage = styled.img``;

export const OnboardingFormContainer = styled.div<{ maxWidth?: string; height?: string }>`
  background-color: ${({ theme }) => theme.COLORS.BACKGROUND_SECONDARY};
  border-radius: 16px;
  padding: 2rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 1.5rem;
  position: relative;
  z-index: 0;

  box-shadow:
    0px 8px 15px rgba(0, 0, 0, 0.3),
    0px -24px 12px rgba(0, 0, 0, 0.25);

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 60%;
    height: 4px;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 2px;
  }

  @media (max-width: ${BREAKPOINTS.WIDTH.SM}) {
    border-radius: 0;
    margin: 0;
    height: 100vh;
    z-index: 0;
    justify-content: center;
    align-items: center;
  }

  @media (min-width: ${BREAKPOINTS.WIDTH.MD}) and (max-width: ${BREAKPOINTS.WIDTH.LG}) {
    max-width: 400px;
    padding: 2rem;
  }

  @media (min-width: ${BREAKPOINTS.WIDTH.LG}) {
    max-width: ${({ maxWidth }) => maxWidth || '441px'};
    padding: 2.5rem;
    height: ${({ height }) => height || 'max-content'};
  }
`;

export const OnboardingLogo = styled.img`
  display: none;
  width: auto;
  height: auto;
  max-width: 180px;
  max-height: 180px;
  object-fit: contain;
  margin-bottom: 1rem;
  z-index: 1;

  @media (min-width: ${BREAKPOINTS.WIDTH.MD}) {
    display: block;
  }

  @media (max-width: ${BREAKPOINTS.WIDTH.SM}) {
    display: block;
    max-width: 140px;
    max-height: 140px;
    margin: 1rem 0;
  }
`;

export const OnboardingForm = styled.form`
  display: flex;
  width: 100%;
  height: auto;
  min-height: 28rem;
  justify-content: space-around;
  flex-direction: column;
  gap: 1rem;

  .text-title {
    text-align: center;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.408px;
  }

  .text-form {
    margin-bottom: -0.5rem;
  }

  .error-message {
    display: flex;
    justify-content: start;
    margin-top: 0.5rem;
  }
`;

export const OnboardingInputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
`;

export const OnboardingRememberForgotContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const OnboardingSeparator = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin: 2rem 0 1rem 0;
  color: ${({ theme }) => theme.COLORS.TEXT_PRIMARY};

  &:before,
  &:after {
    content: '';
    flex: 1;
    border-bottom: 2px solid ${({ theme }) => theme.COLORS.TEXT_PRIMARY};
  }
`;

export const OnboardingContentCenter = styled.div`
  display: flex;
  height: auto;
  gap: 2rem;
  justify-content: space-evenly;
  flex-direction: column;
`;

export const OnboardingTopButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const OnboardingFooterButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: 3rem;
  color: ${({ theme }) => theme.COLORS.TEXT_PRIMARY};
`;

export const OnboardingContentForm = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  flex-direction: column;
  gap: 1rem;

  .text-form {
    margin-bottom: -0.5rem;
  }

  .error-message {
    display: flex;
    justify-content: start;
    margin-top: 0.5rem;
  }

  .phone-input {
    width: 100%;
    height: 4.2rem;
    background-color: ${({ theme }) => theme.COLORS.BACKGROUND_SECONDARY};
    color: ${({ theme }) => theme.COLORS.TEXT_PRIMARY};
    border: 1px solid ${({ theme }) => theme.COLORS.GRAY_40};
    border-radius: 4px;
    padding-left: 50px;
    font-size: 1rem;
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5rem;
    letter-spacing: 0.5px;
    transition: border-color 0.3s ease;

    &:hover {
      border-color: ${({ theme }) => theme.COLORS.GRAY_10};
    }

    &:focus {
      border-color: ${({ theme }) => theme.COLORS.GRAY_10};
      outline: none;
    }
  }
`;

export const OnboardingNameSurnameContainer = styled.div`
  display: flex;
  gap: 1rem;
  width: 100%;

  & > * {
    flex: 1;
  }

  @media (max-width: ${BREAKPOINTS.WIDTH.SM}) {
    flex-direction: column;
  }

  @media (max-width: ${BREAKPOINTS.WIDTH.MD}) {
    flex-direction: column;
  }
`;

export const OnboardingButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 1rem;
  width: 100%;

  @media (max-width: ${BREAKPOINTS.WIDTH.SM}) {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 2rem;
    margin-bottom: 6rem;
  }
`;

export const OnboardingLine = styled.div`
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.COLORS.GRAY_10};
  margin-bottom: 1rem;
`;

export const OnboardingModalContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 2rem;

  .invite-modal-buttons {
    display: flex;
    width: 100%;
    gap: 1rem;
  }

  @media (max-width: ${BREAKPOINTS.WIDTH.MD}) {
    padding: 1rem;
    gap: 1.5rem;

    .invite-modal-buttons {
      flex-direction: column;
    }
  }
`;
